/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TranscoderProfile
 */
export interface TranscoderProfile {
    /**
     * 
     * @type {number}
     * @memberof TranscoderProfile
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TranscoderProfile
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TranscoderProfile
     */
    options?: string;
    /**
     * 
     * @type {string}
     * @memberof TranscoderProfile
     */
    binary?: string;
    /**
     * 
     * @type {string}
     * @memberof TranscoderProfile
     */
    command?: string;
    /**
     * 
     * @type {string}
     * @memberof TranscoderProfile
     */
    outputExtension?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TranscoderProfile
     */
    acceptsBitrate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TranscoderProfile
     */
    acceptsFps?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TranscoderProfile
     */
    acceptsResolution?: boolean;
}

export function TranscoderProfileFromJSON(json: any): TranscoderProfile {
    return TranscoderProfileFromJSONTyped(json, false);
}

export function TranscoderProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranscoderProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'options': !exists(json, 'options') ? undefined : json['options'],
        'binary': !exists(json, 'binary') ? undefined : json['binary'],
        'command': !exists(json, 'command') ? undefined : json['command'],
        'outputExtension': !exists(json, 'output_extension') ? undefined : json['output_extension'],
        'acceptsBitrate': !exists(json, 'accepts_bitrate') ? undefined : json['accepts_bitrate'],
        'acceptsFps': !exists(json, 'accepts_fps') ? undefined : json['accepts_fps'],
        'acceptsResolution': !exists(json, 'accepts_resolution') ? undefined : json['accepts_resolution'],
    };
}

export function TranscoderProfileToJSON(value?: TranscoderProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'options': value.options,
        'binary': value.binary,
        'command': value.command,
        'output_extension': value.outputExtension,
        'accepts_bitrate': value.acceptsBitrate,
        'accepts_fps': value.acceptsFps,
        'accepts_resolution': value.acceptsResolution,
    };
}


